import {useMutation, useQueryClient} from "@tanstack/react-query";
import axios, {AxiosError, AxiosResponse} from "axios";
import {config} from "@commons/config.instance";
import {PVAFormData} from "@commons/mapping/PVAFormData";
import {StampaFineMeseTask} from "@commons/services/presenze_calcolo/sub_calcolo/StampaFineMeseTask";

interface StampaPianificazioneParams {
    idAziendaMaster: number,
    idAzienda: number,
}

export type TipoOrdinamento = 'NOMINATIVO' |
    'GRUPPO1' | 'GRUPPO2' | 'GRUPPO3' | 'GRUPPO4' | 'GRUPPO5' | 'GRUPPO6' | 'GRUPPO7' | 'GRUPPO8' | 'GRUPPO9' | 'GRUPPO10' | 'GRUPPO11' | 'GRUPPO12';

export interface StampaPianificazionePayload {
    idAziendaMaster?: number,
    idAzienda?: number,
    anno: number,
    mese: number,
    dataIniziale: string, // da indicare come aaaa-mm-dd
    dataFinale: string, // da indicare come aaaa-mm-dd
    ordinamento: TipoOrdinamento,
    idAziendaTabelle?: number,
    //filtroTabella: IdTabellaGenericaAzienda | null,
    //valoriFiltroTabella: CentroDiCostoRecord[]
    pvaFilter?: PVAFormData,
}

export interface MiniSpoolRecord {
    idSpool: number,
    URI: string,
}

export function usePostStampaPianificazione(params: StampaPianificazioneParams) {
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse<MiniSpoolRecord>, AxiosError, StampaPianificazionePayload>({
        mutationFn: (payload) => {
            // es. {{host_fpnet}}//FPNet2024/servizio/2828-2835/stampa/pianificazione?auth_token={{fpnet_token}}
            const url = config.getBaseUrl('FPNet') + `/servizio/${params.idAziendaMaster}-${params.idAzienda}/stampa/pianificazione`;
            return axios.post(url, payload);
        },
        onSuccess: (result, variables, context) => {
            // todo da rivedere!
        },
        onError: (error, variables, context) => {
            // todo da rivedere!
        },
    })
}

export function useStampaScorporo() {
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse<Pick<StampaFineMeseTask, 'idSplf' | 'linkSplf'>>, AxiosError, StampaFineMeseTask>({
        mutationFn: (payload) => {
            // es. {{host_fpnet}}/stampe-rest/stampa-presenze/scorporo?auth_token={{fpnet_token}}
            const url = config.getBaseUrl('Stampe') + `/stampa-presenze/scorporo`;
            return axios.post(url, payload);
        },
        onSuccess: (result, variables, context) => {
            // todo da rivedere!
        },
        onError: (error, variables, context) => {
            // todo da rivedere!
        },
    })
}
